import { ModuleDefinition, ExtendedFTNode } from "src/typings/flexFramework/FlexComponent";
import { getNameFromModuleDefinition } from "src/stores/TemplateStore";
import { DescendantDepth, getNextDepth } from "src/stores/FlexTemplateStore";

/**
 * creates ExtendedFTNode equivalent of provided ModuleDefintion
 * @param  {ModuleDefinition} moduleDefinition
 * @param {DescendantDepth} descendantDepth specify depth of returned FlexTemplateNode tree
 * @returns ExtendedFTNode
 */
export const moduleDefinitionToFlexTemplateNode = (
  moduleDefinition: ModuleDefinition,
  descendantDepth: DescendantDepth
): ExtendedFTNode => {
  const flexComponentName = getNameFromModuleDefinition(moduleDefinition);
  const flexComponentView = moduleDefinition.view ? moduleDefinition.view : undefined;

  let view = flexComponentName;

  if (flexComponentView && flexComponentView !== "default") {
    view = `${view}_${flexComponentView}`;
  }

  const options = {
    ...moduleDefinition,
    flexComponentName,
    flexComponentView,
  } as any;

  delete options.id;
  delete options.name;
  delete options.modules;
  delete options.children;
  delete options.groups;
  delete options.view;

  if (flexComponentName === "tab" || flexComponentName === "region") {
    options.containerName = moduleDefinition.name;
  }

  const flexTemplateNode: ExtendedFTNode = {
    id: moduleDefinition.id,
    view,
    options,
  };

  if (
    (moduleDefinition.modules || moduleDefinition.groups || moduleDefinition.children) &&
    descendantDepth !== DescendantDepth.NONE
  ) {
    // gather and create decendant BlossomComponents
    const childModuleDefinitions: ModuleDefinition[] = [
      ...(moduleDefinition.modules || []),
      ...(moduleDefinition.groups || []),
      ...(moduleDefinition.children || []),
    ];

    const childNodes = childModuleDefinitions
      .map((child) => moduleDefinitionToFlexTemplateNode(child, getNextDepth(descendantDepth)))
      .filter((node) => !!node);

    if (childNodes.length > 0) {
      flexTemplateNode.childNodes = childNodes;
    }
  }

  return flexTemplateNode;
};
